import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  NgSelectOption,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ConfigService } from '../../shared-services/config.service';
import { GlobalFilterService } from '../../shared-services/global-filter-service';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ConnectableObservable, map, startWith } from 'rxjs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { MatPseudoCheckboxModule } from '@angular/material/core';
import { KeycloakService } from "keycloak-angular";
import {
  NgOptgroupTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent,
  NgSelectModule,
  
} from '@ng-select/ng-select';

@Component({
  selector: 'app-global-dropdown',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatPseudoCheckboxModule,
    NgSelectComponent,
    FormsModule,
    NgOptionTemplateDirective,
    NgSelectModule,
    
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GlobalDropdownComponent),
      multi: true,
    },
  ],
  templateUrl: './global-dropdown.component.html',
  styleUrl: './global-dropdown.component.scss',
})
export class GlobalDropdownComponent
  implements ControlValueAccessor, OnChanges
{ 
   @Input() data: any;
  @Output() filterChanged = new EventEmitter<any>();
  @Output() payloadEvent = new EventEmitter<any>();

  partNumbers: string = '';
  selectedDate: string = '';

  private onChangeFn: (value: any) => void = () => {};
  private onTouchedFn: () => void = () => {};
  // @Input() data: any;
  @Input() options: any[] = [];
  // @Output() filterChanged = new EventEmitter<any>();
  private suppressSelectionChange = false;
  

  selected: any[] = [];
  searchCtrl = new FormControl('');
  filteredOptions: any[] = [];

  selectedDropdownList: { [key: string]: any[] } = {};

  // private onChangeFn: (value: any) => void = () => {};
  // private onTouchedFn: () => void = () => {};

  constructor(
     private http: HttpClient,
    private configService: ConfigService,
    private globalFilterService: GlobalFilterService,
    private keycloakService: KeycloakService
  ) {this.initializeKeycloak();}

    token:any;
  private async initializeKeycloak() {
    this.token = await this.keycloakService.getToken();
    console.log("Keycloak Token:", this.token);

    // Store or use the token as needed
  }

   private normalizeInput(input: any): string[] {
  if (Array.isArray(input)) {
    return input
      .map((item) => (typeof item === 'object' ? item.label || item.value || '' : String(item)))
      .filter((item) => !!item);
  }

  return String(input)
    .split(/\n|,|\s+/)
    .map((item) => item.trim())
    .filter((item) => !!item);
}

  ngOnInit(): void {
    console.log("Token in dropdown:", this.token);
  }

  ngOnChanges(changes: SimpleChanges): void {
   if (!!this.data?.apiUrl) {
      this.configService
        .getConfig(this.data?.apiUrl, null, this.data?.method)
        .subscribe({
          next: (res) => {
            this.data.optionsList = res?.data || [];
          },
          error: (err) => console.error(err),
        });
    }
   else {
      this.filteredOptions = this.options || [];
    }
  }

  get isAllSelected(): boolean {
    return (
      this.filteredOptions?.length > 0 &&
      this.selected?.length === this.filteredOptions.length
    );
  }




 submit(): void {
    const normalizedValues = this.normalizeInput(this.partNumbers);

    if (normalizedValues.length === 0) {
      console.log('⚠ Please provide input values.');
      return;
    }

    const payload: any = {
      values: normalizedValues,
    };

    if (this.selectedDate) {
      payload.date = this.selectedDate;
    }
    console.log('🚀 Submitting payload:', payload);

    // Store globally if needed
    if (this.data?.key) {
      this.globalFilterService.activeFilter = this.data.key;
      this.globalFilterService.updateFilterSelection(
        this.data.key,
       normalizedValues, 
        this.data?.isQueryParam
      );
    }

    // Emit for parent usage
    this.payloadEvent.emit(normalizedValues);
    this.filterChanged.emit(normalizedValues);

    // Optional: call backend API
    if (this.data?.apiUrl) {
      this.http
        .post(this.data.apiUrl, payload)
        .subscribe({
          next: (res) => console.log('✅ Submit successful:', res),
          error: (err) => console.error('❌ Submit failed:', err),
        });
    }
  }

  reset(): void {
    this.partNumbers = '';
    this.selectedDate = '';
  }

  // ControlValueAccessor implementation
  writeValue(value: any): void {
    this.partNumbers = (value && value.join(', ')) || '';
  }
  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }
  setDisabledState?(isDisabled: boolean): void {}


  isItemSelected(item: any): boolean {
    return this.selected?.includes(item);
  }

  toggleSelectAll(event: any): void {
    const isChecked = event?.target?.checked;

    // Prevent triggering onChange again
    this.suppressSelectionChange = true;
    this.selected = isChecked ? [...this.filteredOptions] : [];

    // Emit manually once
    this.onChangeFn(this.selected);
    this.onTouchedFn();

    const valueToEmit = this.data?.isMultiSelect
      ? this.selected
      : [this.selected];

    if (this.data?.key) {
      this.globalFilterService.activeFilter = this.data.key;
      this.globalFilterService.updateFilterSelection(
        this.data.key,
        valueToEmit,
        this.data?.isQueryParam
      );
    }

    this.filterChanged.emit(valueToEmit);

    setTimeout(() => {
      this.suppressSelectionChange = false;
    }, 0);
  }

  onChange(event: any): void {
    if (this.suppressSelectionChange) return;
    this.onChangeFn(this.selected);
    this.onTouchedFn();

    const valueToEmit = this.data?.isMultiSelect
      ? this.selected
      : [this.selected];

    if (this.data?.key) {
      this.globalFilterService.activeFilter = this.data?.key;
      this.globalFilterService.updateFilterSelection(
        this.data?.key,
        valueToEmit,
        this.data?.isQueryParam
      );
    }

    this.filterChanged.emit(valueToEmit);
  }

  onItemClick(item: any): void {
    if (!this.data?.isMultiSelect) {
      if (this.selected === item) {
        // Unselect if same item clicked again
         this.selected = [];
        this.onChangeFn(this.selected);
        this.onTouchedFn();

        const valueToEmit = [this.selected];

        if (this.data?.key) {
          this.globalFilterService.activeFilter = this.data?.key;
          this.globalFilterService.updateFilterSelection(
            this.data.key,
            valueToEmit,
            this.data?.isQueryParam
          );
        }

        this.filterChanged.emit(valueToEmit);
      }
    }
  }

  removeSelected(item: any): void {
    this.selected = this.selected.filter((i) => i !== item);
    this.onChange(this.selected); // emit the change
  }


}

